// extracted by mini-css-extract-plugin
export default {"modalBody":"nr2ht","spinnerContainer":"DTj9G","modalBodyScroll":"kLtfP","footerCancelButton":"mCY1P","content":"oJ1kS"};